const img = require('./puff-geosecma-support_f7d3bfcd2ca79c13a9e812ff71b71c6a.png').default; export default img;